import React from 'react';
import {connect} from 'react-redux';
import {Grid} from '@mui/material';

import {Dispatch} from 'spectra-logic-ui';
import {createResource} from 'spectra-logic-ui/actions';
import {FormDialog, TextField} from 'spectra-logic-ui/components';

import {FormValues} from '@/locations/form/create/types';
import validate from '@/locations/form/create/validate';

type Props = {
  onSubmit: (values: FormValues) => Promise<any>;
}

const AddLocationDialog = (props: Props) => {
  return (
    <FormDialog title='Add Location' validate={validate} {...props}>
      {() => <AddLocationFormContent />}
    </FormDialog>
  );
};

export const AddLocationFormContent = () => {
  return (
    <Grid item xs={12}>
      <TextField name='locationName' label='Name' />
    </Grid>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (values: FormValues) => {
    const body = {
      name: values.locationName,
    };
    return dispatch(createResource('locations', body));
  },
});

export default connect(undefined, mapDispatchToProps)(AddLocationDialog);
